/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Group_CampaignInputs */

const en_reference_group_campaign = /** @type {(inputs: Reference_Group_CampaignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campaigns`)
};

/**
* | output |
* | --- |
* | "Campaigns" |
*
* @param {Reference_Group_CampaignInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_group_campaign = /** @type {((inputs?: Reference_Group_CampaignInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Group_CampaignInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_group_campaign(inputs)
});